import { useCallback } from 'react';

export const useDateFormatting = () => {
   const cleanDate = useCallback((dates: string[]): string[] => {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return dates.map((date: string) => {
         const newDate = new Date(date);
         return `${newDate.getFullYear()} ${months[newDate.getMonth()]}`;
      });
   }, []);

   const sortDates = useCallback((dates: string[]): string[] => {
      return [...dates].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
   }, []);

   return { cleanDate, sortDates };
};
